module.exports = __webpack_public_path__ + "img/round6.73740b22.png";